import Eyebrow from '@/components/base/Eyebrow';

export default function ServicesIntro() {
  return (
    <section className="bg-white pt-12 md:pt-20 pb-16 md:pb-24">
      <div className="wrap">
        <div className="mx-auto max-w-[1280px]">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 border-b border-foreground-950/15 pb-12 md:pb-16">
            <div className="lg:col-span-7">
              <Eyebrow>WHAT WE DO</Eyebrow>
              <h1 className="mt-6 md:mt-8 max-w-[680px] font-display font-normal text-[clamp(2.25rem,4.4vw,3.75rem)] leading-[1.08] tracking-[-0.015em] text-foreground-950">
                The right expertise, when it matters most.
              </h1>
            </div>
            <div className="lg:col-span-5 lg:pt-14 space-y-4 text-[16px] md:text-[17px] leading-[1.65] text-foreground-800 max-w-[520px]">
              <p>
                From finding exceptional people to building resilient organisations, our services are designed around real business challenges.
              </p>
              <p className="text-foreground-700">
                Three connected practices, each led by senior consultants. You work directly with the people advising you — from the first conversation to the outcome.
              </p>
            </div>
          </div>
          <div className="mt-10 md:mt-14 w-full h-[260px] sm:h-[360px] lg:h-[460px] overflow-hidden bg-background-100 cut-br" style={{ ['--cut' as string]: '72px' }}>
            <img
              src="https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_services-intro.webp"
              alt="Advisor reviewing notes before a client session"
              title="Morrow People HR advisory services"
              data-reveal-image
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>
      </div>
    </section>
  );
}